export default __webpack_public_path__ + "static/media/2.69ee8900.png";